import React, { memo } from 'react';

import { Box, Skeleton } from '@mui/material';
import _ from 'lodash';

import {
  LOADING_SKELETON_DESCRIPTION_HEIGHT_PX,
  LOADING_SKELETON_DESCRIPTION_WIDTH_PERCENT,
  LOADING_SKELETON_FIELDS_PER_SECTION,
  LOADING_SKELETON_INPUT_HEIGHT_PX,
  LOADING_SKELETON_LABEL_HEIGHT_PX,
  LOADING_SKELETON_LABEL_WIDTH_PERCENT,
  LOADING_SKELETON_SECTION_COUNT,
  LOADING_SKELETON_SECTION_TITLE_HEIGHT_PX,
  LOADING_SKELETON_SECTION_TITLE_WIDTH_PERCENT,
} from './LoanEditorCustomFormDrawer.constants';
import {
  containerStyles,
  loadingDescriptionStyles,
  loadingFieldInputStyles,
  loadingFieldLabelStyles,
  loadingFieldStyles,
  loadingGridStyles,
  loadingSectionTitleStyles,
  sectionStyles,
  sectionTitleStyles,
} from './LoanEditorCustomFormDrawer.styles';

const SECTION_INDEXES = _.range(LOADING_SKELETON_SECTION_COUNT);
const FIELD_INDEXES = _.range(LOADING_SKELETON_FIELDS_PER_SECTION);

const LoanEditorCustomFormDrawerSkeleton = () => (
  <Box sx={containerStyles}>
    <Skeleton
      animation="pulse"
      height={LOADING_SKELETON_DESCRIPTION_HEIGHT_PX}
      sx={loadingDescriptionStyles}
      variant="rectangular"
      width={`${LOADING_SKELETON_DESCRIPTION_WIDTH_PERCENT}%`}
    />

    {SECTION_INDEXES.map(sectionIndex => (
      <Box key={sectionIndex} sx={sectionStyles}>
        <Box sx={sectionTitleStyles}>
          <Skeleton
            animation="pulse"
            height={LOADING_SKELETON_SECTION_TITLE_HEIGHT_PX}
            sx={loadingSectionTitleStyles}
            variant="rectangular"
            width={`${LOADING_SKELETON_SECTION_TITLE_WIDTH_PERCENT}%`}
          />
        </Box>

        <Box sx={loadingGridStyles}>
          {FIELD_INDEXES.map(fieldIndex => (
            <Box key={fieldIndex} sx={loadingFieldStyles}>
              <Skeleton
                animation="pulse"
                height={LOADING_SKELETON_LABEL_HEIGHT_PX}
                sx={loadingFieldLabelStyles}
                variant="rectangular"
                width={`${LOADING_SKELETON_LABEL_WIDTH_PERCENT}%`}
              />
              <Skeleton
                animation="pulse"
                height={LOADING_SKELETON_INPUT_HEIGHT_PX}
                sx={loadingFieldInputStyles}
                variant="rectangular"
                width="100%"
              />
            </Box>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);

LoanEditorCustomFormDrawerSkeleton.displayName = 'LoanEditorCustomFormDrawerSkeleton';

export default memo(LoanEditorCustomFormDrawerSkeleton);
